import { HttpErrorResponse, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {APIService} from "./api.service";
import {FileEntry} from "../interfaces/fileEntry";
import {APIResponse} from "../interfaces/api-response";
import {NotifierService} from "./notifier.service";
import {FilePickerAdapter, UploadResponse, UploadStatus} from "../interfaces/filePickerAdapter";
import { saveAs as importedSaveAs } from "file-saver-es";


export class BaseFilePickerAdapter extends FilePickerAdapter{

  private actioning: boolean = false;

  constructor(private api: APIService, private notifier: NotifierService, private url: string) {
    super();
  }

  public get isLoading(){
    return this.actioning;
  }

  public uploadFile(file: File, moredata: {[key:string]: any} = null): Observable<UploadResponse> {
    if(!this.actioning) {
      this.actioning = true;
      const form = new FormData();
      form.append('file', file);
      if(moredata){
        for(let m in moredata){
          form.append(m, moredata[m]);
        }
      }

      const req = new HttpRequest('POST', this.api.root + this.url + '/upload', form, {reportProgress: true});
      return this.api.http.request(req)
        .pipe(
          map((res: HttpEvent<any>) => {
            if (res.type === HttpEventType.Response) {
              const responseFromBackend: APIResponse<FileEntry> = res.body;
              this.actioning = false;
              return {
                body: responseFromBackend.data,
                status: UploadStatus.UPLOADED
              };
            } else if (res.type === HttpEventType.UploadProgress) {
              /** Compute and show the % done: */
              const uploadProgress = +Math.round((100 * res.loaded) / res.total);
              return {
                status: UploadStatus.IN_PROGRESS,
                progress: uploadProgress
              };
            }
          }),
          catchError((er: HttpErrorResponse) => {
            this.actioning = false;
            return of({status: UploadStatus.ERROR, body: er});
          })
        );
    }
    return null;
  }
  public removeFile(file: FileEntry): Observable<UploadResponse> {
    if(!this.actioning) {
      this.actioning = true;
      const id = file.id;
      return this.api.http.post(this.api.root + this.url + '/delete', {id}).pipe(
        map((res: APIResponse<FileEntry>) => {
          this.actioning = false;
          return {
            status: UploadStatus.DELETED,
            body: res.data
          }
        }),
        catchError(er => {
          this.actioning = false;
          return of({status: UploadStatus.ERROR, body: er});
        }));
    }
    return null;
  }

  public downloadFile(file: FileEntry): Observable<UploadResponse> {
    if(!this.actioning){
      this.actioning = true;
      const id = file.id;

      return this.api.http.get(this.api.root + this.url + '/' + id, {
        responseType: 'blob'
      }).pipe(
          map((res: Blob) => {
            this.actioning = false;

            importedSaveAs(res, file.name);

            return {
              status: UploadStatus.DOWNLOADED,
              body: res
            };
          },
          catchError(er => {
            this.actioning = false;
            return of({
              status: UploadStatus.ERROR,
              body: er
            });
          }))
      );
    }
    return null;
  }

}
